import Image from "next/image";
import { CTASectionProps } from "./AlternativesCTASection";
import CTAButtons from "@components/new-ui/CTAButtons";

const defaultTopBannerCTAContent: CTASectionProps = {
    content: "Get your business on WhatsApp with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/alternatives/whatsapp-with-gallabox.png",
    imgAlt: "whatsapp-with-gallabox",
    btnText: "Try for free",
};

export const AlternativesTopBannerCTASection: React.FC<{ ctaTopSection?: CTASectionProps }> = ({ ctaTopSection = defaultTopBannerCTAContent }) => {
    const { content, imageUrl, imgAlt, btnText } = ctaTopSection;
    return (
        <section>
            <div style={{ position: "sticky", top: "120px", minHeight: "580px" }} className="bg-white col-span-1 md:w-60 mx-8">
                <div className="p-5 md:mx-0 rounded-lg" style={{ background: "linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%)" }}>
                    <Image width={241} height={230} src={imageUrl} alt={imgAlt} />
                    <p className="text-2xl font-bold text-white py-5">{content}</p>

                    <CTAButtons primaryButtonText={btnText} size="md" variant="secondary-light" iconSize="sm" className="text-base font-semibold w-full" />
                </div>
            </div>
        </section>
    );
};
